<template>
  <div class="about_wrap" id="gsjs">
    <div class="realize_img">
      <div class="img_tit">让企业数智化转型更高效</div>
      <div class="img_tit_desc">客户至上&nbsp;&nbsp;追求卓越&nbsp;&nbsp;信守承诺&nbsp;&nbsp;协作共赢</div>
    </div>
    <div class="title_inner">
      <div class="inner_center">
        <div class="production_title">企业简介</div>
        <div class="production_desc">企业数智化综合解决方案</div>
      </div>
    </div>
    <div class="three_box">
      <div class="jianjie hidden-xs-only">
        <div class="img-div"><img src="../../assets/img/about/logo.svg"/></div>
        <div>河南良悦信息科技有限公司(简称良悦科技)，成立于2019年8月，注册资金3000万。目前已经通过了ISO9001、ISO14001、ISO45001标准体系认证，2020年加入河南省软件业协会，2021年被认定为国家高新技术企业。良悦科技是信息化行业的综合解决方案供应商，5G+工业互联网软件研发供应商，面向全国客户提供机房IT设备维保、搬迁，智能安防、信息化会议室的建设及工业互联网整体的解决方案，为客户提供真正的一站式信息化服务。</div>
      </div>
    </div>
    <div class="jianjie-mobile hidden-sm-and-up">
      <div class="jianjie-logo"><img src="../../assets/img/about/logo.svg"/></div>
      <div class="jianjie-text">河南良悦信息科技有限公司(简称良悦科技)，成立于2019年8月，注册资金3000万。目前已经通过了ISO9001、ISO14001、ISO45001标准体系认证，2020年加入河南省软件业协会，2021年被认定为国家高新技术企业。良悦科技是信息化行业的综合解决方案供应商，5G+工业互联网软件研发供应商，面向全国客户提供机房IT设备维保、搬迁，智能安防、信息化会议室的建设及工业互联网整体的解决方案，为客户提供真正的一站式信息化服务。</div>
    </div>
    <div class="qiyewenhua">
      <div class="title_inner">
        <div class="inner_center">
          <div class="production_title">企业文化</div>
          <div class="production_desc">专业&nbsp;&nbsp;|&nbsp;&nbsp;真诚&nbsp;&nbsp;|&nbsp;&nbsp;创新&nbsp;&nbsp;|&nbsp;&nbsp;合作</div>
        </div>
      </div>
      <el-row class="card_wrap " type="flex">
        <el-col
            class="brain_item"
            :span="7"
            :xs="24"
            v-for="(item, index) in cardList"
            :key="index"
        >
          <div class="item_bg"></div>
          <el-row style="z-index: 2" class="hidden-xs-only">
            <el-col :span="24">
              <div class="img-div"><img :src="item.src" alt="" class="img_item1"/></div>
            </el-col>
            <el-col :span="24">
              <div class="item_title">{{ item.title }}</div>
              <div class="item_desc" v-if="index !== 2">{{ item.desc1 }}</div>
              <div class="item_desc" v-else>客户至上&nbsp;&nbsp;&nbsp;&nbsp;追求卓越<br>信守承诺&nbsp;&nbsp;&nbsp;&nbsp;合作共赢</div>
            </el-col>
          </el-row>
          <el-row style="z-index: 2" class="hidden-sm-and-up">
            <el-col :span="8">
              <div class="img-div"><img :src="item.src" alt="" class="img_item1"/></div>
            </el-col>
            <el-col :span="16">
              <div class="item_title">{{ item.title }}</div>
              <div class="item_desc" v-if="index !== 2">{{ item.desc1 }}</div>
              <div class="item_desc" v-else>{{ item.desc1 }}、{{ item.desc2 }}、{{ item.desc3 }}、{{ item.desc4 }}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="title_inner" id="zyys">
      <div class="inner_center">
        <div class="production_title">资质荣誉</div>
        <div class="production_desc">努力源于想法，荣誉来自担当</div>
      </div>
    </div>
    <div class="rongyu hidden-sm-and-up" >
      <img src="../../assets/img/mobile/zizhi-about.png" class="rongyu-img"/>
      <el-row>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/gxzs.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">高新技术企业证书</div>
        </el-col>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/AAA.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">AAA级信用企业</div>
        </el-col>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/rjcpzs.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">软件产品证书</div>
        </el-col>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/rjqyzs.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">软件企业证书</div>
        </el-col>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/hnsrjfwxh.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">河南省软件协会会员单位</div>
        </el-col>
        <el-col :span="12">
          <img src="../../assets/img/about/zhengshu/gjkjx.jpg" class="rongyu-img"/>
          <div class="zhengshu-title">国家科技型中小企业</div>
        </el-col>
      </el-row>
    </div>
    <div class="rongyu hidden-xs-only" >
      <img src="../../assets/img/about/zzry.png" class="rongyu-img"/>
<!--      <div class="a0013-container">-->
<!--        <div class="a0013-con bgcolor">-->
<!--          <div class="a0013-swiper">-->
<!--            <el-carousel-->
<!--                :interval="2500"-->
<!--                type="card"-->
<!--                height="460px"-->
<!--                style="overflow-x: unset"-->
<!--                indicator-position="none"-->
<!--            >-->
<!--              <Swiper v-for="(item, i) in dataList" :key="i">-->
<!--                <div class="imgBox">-->
<!--                  <img class="imgItem" :src="item.img" alt="" srcset="" />-->
<!--                  <div class="imgTit">{{ item.desc }}</div>-->
<!--                </div>-->
<!--              </Swiper>-->
<!--            </el-carousel>-->
      <div class="carousel-div">


              <el-carousel :interval="1500" type="card" class="carousel-div-inner">
                <el-carousel-item v-for="(item, i) in dataList" :key="i">
                  <img class="imgItem" :src="item.img" alt="" srcset="" style="width: 100%" />
<!--                  <h3 class="medium">{{ item }}</h3>-->
                </el-carousel-item>
              </el-carousel>
      </div>
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="title_inner" id="fzlc">
      <div class="inner_center">
        <div class="production_title">发展历程</div>
      </div>
    </div>
    <div class="fazhanlicheng">
      <div class="lc-div hidden-xs-only">
          <el-carousel :autoplay="false" indicator-position="none" >
            <el-carousel-item class="el-car" v-for="(imgData,i) in newDataList" :key="i" >
              <template v-for="(img,index) in imgData" >
                <div class="car-item" >
                  <el-row>
                    <el-col :span="2">
                      <div class="point"></div>
                      <div class="line"></div>
                    </el-col>
                    <el-col :span="22">
                      <div>{{ img.year }}</div>
                      <div class="car-item-desc">{{ img.desc1 }}</div>
                      <div class="car-item-desc">{{ img.desc2 }}</div>

                      <img :key="index" :src="img.url" alt="" class="top-img hidden-xs-only"/></el-col>
                  </el-row>
                </div>


              </template>
            </el-carousel-item>
          </el-carousel>
      </div>
      <div class="lc-div hidden-sm-and-up">
          <el-carousel  :interval="2000"  arrow="never" >
            <el-carousel-item class="el-car" v-for="(imgData,i) in mobileDataList" :key="i" >
              <template v-for="(img,index) in imgData" >
                <div class="car-item" >
                  <el-row>
                    <el-col :span="2">
                      <div class="point"></div>
                      <div class="line"></div>
                    </el-col>
                    <el-col :span="22">
                      <div>{{ img.year }}</div>
                      <div class="car-item-desc">{{ img.desc1 }}</div>
                      <div class="car-item-desc">{{ img.desc2 }}</div>

                      <img :key="index" :src="img.url" alt="" class="top-img hidden-xs-only"/></el-col>
                  </el-row>
                </div>


              </template>
            </el-carousel-item>
          </el-carousel>
      </div>

    </div>
    <div class="title_inner" style=" background-color: rgba(245, 247, 250, 1);">
      <div class="inner_center">
        <div class="production_title">联系我们</div>
        <div class="production_desc hidden-xs-only">请通过以下方式与我们联系，我们将在24小时内与您联系，感谢您的支持！</div>
      </div>
    </div>
    <div style=" background-color: rgba(245, 247, 250, 1);">
      <div class="contact">
        <el-row justify="center" :gutter="20" >
          <el-col :span="9"  :xs="8">
            <el-row>
              <el-col :span="4" :xs="24"><img src="../../assets/img/about/position.png" class="contact-img"/></el-col>
              <el-col :span="20" :xs="24">
                <div class="contact-title">公司地址</div>
                <div class="contact-desc">河南自贸试验区郑州片区 (郑东)祥盛街</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="9"  :xs="8">
            <el-row>
              <el-col :span="4" :xs="24"><img src="../../assets/img/about/phone.png" class="contact-img"/></el-col>
              <el-col :span="20" :xs="24">
                <div class="contact-title">联系电话</div>
                <div class="contact-desc">400-033-9003</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" :xs="8">
            <el-row>
              <el-col :span="4" :xs="24"><img src="../../assets/img/about/mail.png" class="contact-img"/></el-col>
              <el-col :span="20" :xs="24">
                <div class="contact-title">联系邮箱</div>
                <div class="contact-desc">zhangzx@liangy.cn</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

      </div>
    </div>

    <div class="zixun" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme></MobileCallme>
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
// import Swiper from "./swiper.vue"
export default {
  data() {
    return {
      cardList: [
        {
          src: require('@/assets/img/about/shiming.png'),
          title: '使命',
          desc1: '通过消除所有技术和经济障碍，使我们的客户能够迅速将伟大的想法变为现实',
          desc2: '',
        },
        {
          src: require('@/assets/img/about/yuanjing.png'),
          title: '愿景',
          desc1: '成为国内领先的企业数智化综合解决方案引领者',
          desc2: ''
        },
        {
          src: require('@/assets/img/about/jiazhiguan.png'),
          title: '价值观',
          desc1: '客户至上',
          desc2: '追求卓越',
          desc3: '信守承诺',
          desc4: '合作共赢',
        },
      ],
      dataList:[
        {
          img:require('@/assets/img/about/zhengshu/AAA.jpg'),
          desc:'AAA级信用企业'
        },
        {
          img:require('@/assets/img/about/zhengshu/gxzs.jpg'),
          desc:'高新技术企业证书'
        },
        {
          img:require('@/assets/img/about/zhengshu/gjkjx.jpg'),
          desc:'国家科技型中小企业'
        },{
          img:require('@/assets/img/about/zhengshu/hnsrjfwxh.jpg'),
          desc:'河南省软件服务业协会会员单位'
        },{
          img:require('@/assets/img/about/zhengshu/rjqyzs.jpg'),
          desc:'软件企业证书'
        },{
          img:require('@/assets/img/about/zhengshu/rjcpzs.jpg'),
          desc:'软件产品证书'
        },
      ],
      newDataList:[],
      mobileDataList:[],
      lcList: [
        // { year:'2025',
        //   desc1:'获得多项软件著作权证书',
        //   desc2:'获得国家科技型中小企业认证',
        //   url: require('@/assets/img/about/fzlc2022.png')
        // },
        // {
        //   year:'2024',
        //   desc1:'获得多项软件著作权证书',
        //   desc2:'获得国家科技型中小企业认证',
        //   url: require('@/assets/img/about/fzlc2022.png')
        // },
        // {
        //   year:'2023',
        //   desc1:'获得多项软件著作权证书',
        //   desc2:'获得国家科技型中小企业认证',
        //   url: require('@/assets/img/about/fzlc2022.png')
        // },
        {
          year:'2022',
          desc1:'获得多项软件著作权证书',
          desc2:'获得国家科技型中小企业认证',
          url: require('@/assets/img/about/fzlc2022.png')
        },
        {
          year:'2021',
          desc1:'获得多项软件著作权证书',
          desc2:'获得高新技术企业证书',
          url: require('@/assets/img/about/fzlc2021.png')
        },
        {
          year:'2020',
          desc1:'获得AAA级信用企业证书',
          desc2:'获得实用型专利证书',
          url: require('@/assets/img/about/fzlc2020.png')
        },
        {
          year:'2019',
          desc1:'8月，创始团队成立',
          desc2:'11月，获得ISO三体系证书',
          url: require('@/assets/img/about/fzlc2019.png')
        }
      ]
    }
  },
  mounted() {
    this.getImg()
    console.log("this.$route.query.id=",this.$route.query.id)
    if(this.$route.query.id==='gsjs') {
      const element = document.getElementById('gsjs');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
      }
    }else if(this.$route.query.id==='zyys'){
      const element = document.getElementById('zyys');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
      }
    }else if(this.$route.query.id==='fzlc'){
      const element = document.getElementById('fzlc');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
      }
    }
  },
  methods: {
    getImg(){
      this.newDataList = [] //新建数组循环获取4个图片
      this.mobileDataList = [] //新建数组循环获取4个图片
      for(let i = 0; i<this.lcList.length; i+=4) {
        this.newDataList.push(this.lcList.slice(i,i+4))
      }
      for(let i = 0; i<this.lcList.length; i+=2) {
        this.mobileDataList.push(this.lcList.slice(i,i+2))
      }
    }
  },
  components: {
    Zixun,
    // Swiper,
    CallMe,
    MobileCallme,
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  watch: {
    $route() {
      this.tabSelectIndex =
        this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel-div{
  width: 1100px;
  padding-top: 30px;
  margin: auto;
  .carousel-div-inner{
    height: 500px;
  }
  ::v-deep(.el-carousel__container){
    height: 400px;
  }
}
.contact{
  width: 70%;
  margin: auto;
  padding: 20px 0 30px 0;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding: 10PX 5PX 20PX 0;
    text-align: center;
  }
  .contact-img{
    width: 50px;
    //margin: auto;
    margin-right: 10px;
    float: right;
    @media screen and (max-width: 768px) {
      width: 40PX;
      float: unset;
    }
  }
  .contact-title{
    font-size: 16px;
    color: rgba(37, 53, 84, 1);
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      line-height: 1.6rem;
      text-align: center;
    }
  }
  .contact-desc{
     font-size: 13px;
     color: rgba(132, 145, 171, 1);
     line-height: 30px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1rem;
      text-align: center;
    }
   }

}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-around;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 10px 5px 50px 0;
    //background: #fff;
    border-radius: 4px;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    box-shadow: 0.2 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 20PX;
      border-radius: 4PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 10PX;
      box-shadow: 0 0.2rem 0.8rem 0.2rem rgb(12 28 56 / 8%);
    }
    .img-div{
      width: 150px;
      height: 150px;
      margin: 30px auto;
      background-color: #fff;
      border-radius: 100px;
      text-align: center;
      align-items: center;
      align-content: center;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 90PX;
        height: 90PX;
        border-radius: 50PX;
        margin: 20PX 10PX;
      }
    }
    .img_item1 {
      width: 50% ;
    }
    &:hover{
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
      .img_item1{
        transition: transform 0.3s ease;
        transform: rotateY(180deg) scale(1.1);
      }
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      border: 1px solid #fff;
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 24px;
      font-weight: bold;
      color: #203040;
      text-align: center;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
        line-height: 2rem;
        text-align: left;
        margin-top: 20PX;
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #666;
      width: 56%;
      margin: auto;
      text-align: center;
      //line-height: 1.5rem;
      z-index: 2;
      position: inherit;
      font-size: 16px;
      min-height: 30px;
      line-height: 30px;
      //padding: 0px 60px;
      @media screen and (max-width: 768px) {
        width: 100%;
        font-size: 0.8rem;
        text-align: left;
        line-height: 1.5rem;
        padding-right: 10PX;
      }
      i{
        padding: 0 5px 0 8px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
.jianjie{
  width: 35%;
  height: 100%;
  background-color: rgb(255 255 255 / 50%);
  margin-left: 24%;
  padding: 50px 40px;
  font-size: 13px;
  line-height: 30px;
  text-align: left;
  @media screen and (max-width: 768px) {
    line-height: 1rem;
    font-size: 0.8rem;
  }
  &:hover{
    background-color: rgb(255 255 255 / 80%);
  }
  .img-div{
    margin-bottom: 10px;
    img{
      width: 40%;
    }
  }
}
.jianjie-mobile{
  width: 95%;
  margin: auto;
  padding-top: 10PX;
  .jianjie-logo{
    margin-top: 10PX;
    img{
      width: 100PX;
    }
  }
  .jianjie-text{
    font-size: 13px;
    line-height: 30px;
    text-align: left;
    color: #808080;
    @media screen and (max-width: 768px) {
      line-height: 1.8rem;
      font-size: 0.8rem;
      padding: 10PX;
    }
  }
}

.zixun {
  background-color: rgba(245, 247, 250, 1);
  padding: 80px 0 5px 0;
}
.fazhanlicheng{
  width: 100%;
  background: url('../../assets/img/about/fzlc.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  height: 350px;
  padding-bottom: 60px;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    height: 150PX;
  }
  .lc-div{
    width: 70%;
    margin: auto;
    height: 200px;
    padding: 40px 0;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 95%;
      height: 150PX;
      padding: 15PX 0;
  }

    .el-carousel--horizontal{
      padding: 20px;
      @media screen and (max-width: 768px) {
        padding: 0 10PX 10PX 10PX;
        height: 140PX;
      }
    }
    ::v-deep(.el-carousel__indicators--horizontal){
      top: 100PX;
    }
    ::v-deep(.el-carousel__button){
      @media screen and (max-width: 768px) {
        background-color: #0052d9 !important;
        height: 4PX;
        width:15PX;
        border-radius: 5PX;
        margin-right: 5PX;
        margin-top: 20PX;
      }
    }
    .el-car{
      width: 100%;
      overflow: hidden;
      display: flex;
      @media screen and (max-width: 768px) {
        height: 100PX;
      }
      .car-item{
        width: 25%;
        padding-left: 40px;
        padding-top: 20px;
        color: #fff;
        font-size: 30px;
        @media screen and (max-width: 768px) {
          font-size: 1.1rem;
          width: 50%;
          padding-top: 10PX;
          height: 100PX;
        }
        .car-item-desc{
          font-size: 14px;
          line-height: 40px;
          @media screen and (max-width: 768px) {
            font-size: 0.6rem;
            line-height: 0.8rem;
          }
        }
        &:hover{
          padding-top: 0;
          font-size: 32px;
          @media screen and (max-width: 768px) {
            font-size: 1.1rem;
            padding-top: 10PX;
          }
          .point{
            height: 7px;
            @media screen and (max-width: 768px) {
              display: none;
            }
          }
        }
      }
      .point{
        width: 7px;height: 0px;border-radius: 6px;background-color: #fff;margin-left: -3px;
        @media screen and (max-width: 768px) {
          width: 4PX;
          height: 4PX;
          border-radius: 2PX;
          margin-left: -2PX;
          display: none;
        }
      }
      .line{
        width: 1px;
        height: 200px;
        background: url('../../assets/img/about/line.png') 0 0 no-repeat;
        background-size: 100% 100%;
        @media screen and (max-width: 768px) {
          height: 100PX;
        }
      }
      .top-img{
        //width: 23%;
        height: 60px;
        margin-right: 10px;
        cursor: pointer;
        background-color: #fff;
        border-radius: 4px;
        margin-top: 10px;
      }
    }
  }
}
.qiyewenhua{
  width: 100%;
  background: url('../../assets/img/about/qywh-bg.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
//height: 700px;
  padding-bottom: 60px;
  @media screen and (max-width: 768px) {
    padding-bottom: 30PX;
  }
}
.about_wrap {
  width: 100%;
  margin-top: 70px;

  .realize_img {
    width: 100%;
    height: 420px;
    background: url('../../assets/img/about/about-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    .img_tit {
      font-size: 54px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.5rem;
      }
    }
    .img_tit_desc {
      margin-top: 15px;
      font-size: 24px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-top: 10PX;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 14px;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .title_inner {
    padding: 50px 0 30px 0;
     display: flex;
     justify-content: center;
     .inner_center {
       width: 100%;
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       padding: 0 50px;
       @media screen and (max-width: 768px) {
         flex: 2.2;
         padding-top: 20PX;
       }
       .production_title {
         color: #05102F;
         font-size: 33px;
         font-weight: bold;
         @media screen and (max-width: 768px) {
           font-size: 1.1rem;
         }
       }
       .production_desc {
         font-size: 16px;
         color: #253554;
         margin-top: 10px;
         @media screen and (max-width: 768px) {
           margin-top: 10PX;
           font-size: 0.8rem;
           margin-bottom: 10PX;
         }
       }
     }
   }
  .rongyu{
      width: 70%;
      margin: 0 auto;
      text-align: center;
      padding: 0 30px;
    @media screen and (max-width: 768px) {
      width: 95%;
      .zhengshu-title{
        font-size: 0.8rem;
        color:#808080 ;
        margin-bottom: 5PX;
      }
    }
      .rongyu-img{
        width: 100%;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 5PX 0;
        }
      }
  }
  .three_box {
    width: 70%;
    margin: 0 auto;
    height: 400px;
    text-align: center;
    background: url('../../assets/img/about/jianjie.jpg');
    background-size: 100% 100%;
    margin-bottom: 50px;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 120PX;
    }
    h1 {
      font-size: 40px;
      line-height: 200px;
      color: #fff;
    }
  }
}
.production_title_wrap {
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
  .production_inner {
    display: flex;
    justify-content: center;
    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
    .inner_center {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }
      .production_title {
        font-size: 40px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
  }
}

//::v-deep(.el-carousel__arrow--left) {
//  left: -14px !important;
//}
//::v-deep(.el-carousel__arrow--right) {
//  right: -14px !important;
//}
.a0013-container {
  width: 100%;
  text-align: center;
  .a0013-con {
    margin: 0 auto;
    width: 1200px;
    padding-bottom: 30px;
    .a0013-swiper {
      width: 1200px;
      height: 100%;
      .el-carousel__item {
        width: 580px;
        padding: 0 0 10px 0;
        background-color: #fff;
        box-sizing: border-box;
      }
      .imgBox {
        position: relative;
        .imgItem {
          width: 580px;
          text-align: center;
          height: 370px;
          background-size: cover;

        }
        .imgTit {
          //position: absolute;
          //top: calc(50% - 36px);
          //left: calc(50% - 138px);
          width: 100%;
          height: 70px;
          border: 1px solid #fbfbfb;
          border-radius: 5px;
          font-size: 16px;
          font-weight: 600;
          color: #283147;
          background-color: #fff;
          line-height: 50px;
        }
      }
    }
  }
}
</style>